module.exports = __webpack_public_path__ + "img/weather_unknown.efd0e60b.svg";